import { render, staticRenderFns } from "./SeafarersHeroesOfPandemic.vue?vue&type=template&id=6d20ed74&scoped=true"
import script from "./SeafarersHeroesOfPandemic.vue?vue&type=script&lang=js"
export * from "./SeafarersHeroesOfPandemic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d20ed74",
  null
  
)

export default component.exports